import React, { Component } from 'react';
import Slider from "react-slick";

class Review extends Component {
    constructor(props) {
        super(props);
        this.state = {
            testimonial: [
                {
                    id: 1,
                    img: './assets/images/clients/pushkar.PNG',
                    alt: 'images',
                    quoteText: 'Insightful and Easy to Understand!',
                    text: 'This e-book is a game-changer for salaried professionals like me. It explains tax-saving strategies in such simple terms that even someone with no prior knowledge of taxes can easily follow. I’ve already started implementing a few tips and can see a significant reduction in my tax burden. Highly recommended for anyone looking to maximize their savings!',
                    name: 'Pushkar Deshpande',
                    desigantion: 'IT Professional'
                },
                {
                    id: 2,
                    img: './assets/images/clients/swapnil.jpeg',
                    alt: 'images',
                    quoteText: 'Practical and Well-Organized',
                    text: 'As a salaried individual, I’ve always struggled to understand how to effectively save on taxes. This e-book breaks everything down into clear, actionable steps. The sections on Section 80C and health insurance deductions were especially helpful for me. It’s worth every penny and is a must-have for anyone serious about tax planning.',
                    name: 'Swapnil Bhagat',
                    desigantion: 'Employee at Infosys'
                },
                {
                    id: 3,
                    img: './assets/images/clients/bhushan.jpeg',
                    alt: 'images',
                    quoteText: 'A Must-Read for Every Salaried Person!',
                    text: 'This e-book is a treasure trove of information! It’s not just about saving taxes but also about smart financial planning. The author has done an excellent job of covering everything from tax slabs to investment strategies under the latest Finance Act. It’s well-written, concise, and extremely helpful. I’ll definitely recommend it to my colleagues!',
                    name: 'Bhushan Patil',
                    desigantion: 'Tax Consultant'
                },
            ]
        }
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            centerMode: true,
            arrows: false,
            autoplay: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '40px',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (
            <section className="testimonial section-padding dark-bg " id="testimonial">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="colxl-6 col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Reviews from happy readers</h3>
                                <p>This book is concerned with creating typography and is essential for professionals who regularly work for clients.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="testimonials-slides">
                                <Slider useRef="reviews" {...settings}>
                                    {
                                        this.state.testimonial.map((data) => (
                                            <div className="review-item" key={data.id}>
                                                <div className="client-info">
                                                    <div className="rating">
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                    </div>
                                                    <h4>{data.quoteText}</h4>
                                                    <p>{data.text}</p>
                                                </div>

                                                <div className="client-desc d-flex align-items-center">
                                                    <div className="client-img">
                                                        <img src={data.img} alt={data.alt} className="img-fluid" />
                                                    </div>
                                                    <div className="client-text">
                                                        <h5>{data.name}</h5>
                                                        <span className="designation">{data.desigantion}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Review;
